import { Logger, LogManager, PermissionsUtil, StringUtil } from "@mcleod/core";
import { DecoratorPermissionsType } from "./DecoratorPermissionsType";
import { DecoratorType } from "./DecoratorType";
import { Layout } from "../../components/layout/Layout";

export interface DecoratorAccessTestResult {
    allowed: boolean;
    message?: string;
    displaysInViewMode?: boolean;
}

export class DecoratorAccessTester {
    private static log: Logger;

    public static isDecoratorAllowed(layout: Layout, decoratorType: DecoratorType): DecoratorAccessTestResult {
        const result: DecoratorAccessTestResult = {
            allowed: true
        }
        this.testAllowedUses(layout, decoratorType, result);
        if (result.allowed === true) {
            this.testUserPermissions(layout.layoutName, decoratorType, result);
        }
        return result;
    }

    private static testAllowedUses(layout: Layout, decoratorType: DecoratorType, result: DecoratorAccessTestResult) {
        // Temporary change to keep static layouts like SessionExpired from being shown in a decorator.
        // When we enforce allowed uses, remove this and use the commented out section below.
        const tempAllowedUsesOverride: DecoratorType[] = layout["tempAllowedUsesOverride"];
        if (decoratorType != null &&
            (tempAllowedUsesOverride != null && !tempAllowedUsesOverride.includes(decoratorType))) {
            result.allowed = undefined;
            result.message = `This screen cannot be used in ${decoratorType} mode`;
        }
        // if (decoratorType != null && !layout.getAllowedUses().includes(decoratorType)) {
        //     result.allowed = false;
        //     result.message = `This screen cannot be used in ${decoratorType} mode`;
        // }
    }

    public static testUserPermissions(layoutName: string, decoratorType: DecoratorType,
        result: DecoratorAccessTestResult) {
        const permissionName = this.getPermissionName(decoratorType);
        const hasPermissions = StringUtil.isEmptyString(permissionName) ||
            !PermissionsUtil.isUserDeniedLayoutItem(layoutName, permissionName);
        let logMessage: string;
        if (hasPermissions) {
            logMessage = `User has permission to use layout ${layoutName} with decorator type ${decoratorType}`;
        } else {
            logMessage = `User does not have permission to use layout ${layoutName} with decorator type ` +
                    decoratorType;
            if (decoratorType !== DecoratorType.UPDATE) {
                result.allowed = false;
                result.message = "Access denied due to permissions";
            } else {
                logMessage += ", displaying in view mode";
                result.allowed = true;
                result.message = "You do not have permission to update this data.";
                result.displaysInViewMode = true;
            }
        }
        this.getLog().debug(logMessage);
    }

    private static getPermissionName(decoratorType: DecoratorType) {
        switch (decoratorType) {
            case DecoratorType.ADD:
                return DecoratorPermissionsType.ADD;
            case DecoratorType.UPDATE:
                return DecoratorPermissionsType.UPDATE;
            case DecoratorType.SEARCH:
                return DecoratorPermissionsType.SEARCH;
            default:
                return null;
        }
    }

    private static getLog(): Logger {
        if (this.log == null)
            this.log = LogManager.getLogger("components.page.decorators.DecoratorAccessTester");
        return this.log;
    }
}
